/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-15 14:57:17
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-17 17:42:16
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentGroup/ModulesGenerator/ArticleList.ts
 */
import { ActionType } from 'src/types/common/common';
import { generateNewContentImg } from 'src/constrains/DraggableModules/tools';
import {
  //ProductList,
  //   LongCanvas,
  //   Text,
  //   Poster,
  //   ProductGridDisplay,
  //ListAdaptor,
  ListAdaptor,
} from 'src/constrains/DraggableModules/Components';

const ArticleListFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const handleOnListItemAdd = (id) => {
    const _o = generateNewContentImg();

    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.add, id, data: [_o] });
    }
  };

  const handleOnListItemDelete = (id, index) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.delete, id, data: { index } });
    }
  };

  const handleOnListItemChange = (id, index, modifiedData) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.modify,
        id,
        data: {
          index,
          modifiedData,
        },
      });
    }
  };

  const handleOnListItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: {
          from,
          to,
        },
      });
    }
  };

  const handleOnListStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };

  const handleOnListModuleTypeChange = (data) => {
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };
  return {
    handleOnListItemAdd,
    handleOnListItemDelete,
    handleOnListItemChange,
    handleOnListItemSort,
    handleOnListStaticChange,
    handleOnListModuleTypeChange,
  };
};
const generateArticleList = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const {
    handleOnListItemAdd,
    handleOnListItemDelete,
    handleOnListItemChange,
    handleOnListItemSort,
    handleOnListStaticChange,
    handleOnListModuleTypeChange,
  } = ArticleListFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
  });
  return {
    component: ListAdaptor,
    props: {
      onItemAdd: handleOnListItemAdd,
      onItemChange: handleOnListItemChange,
      onItemSort: handleOnListItemSort,
      onItemDelete: handleOnListItemDelete,
      onStaticChange: handleOnListStaticChange,
      onModuleTypeChange: handleOnListModuleTypeChange,
    },
  };
};
export { generateArticleList };
